import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute,  NavigationEnd,  Router } from '@angular/router';
import { navPaths, Support } from '@core/models/support.model';
import { GlobalDataService,CampagneTypologieService } from '@core/services';
import { ProduitService } from '@core/services/produit.service';

@Component({
  selector: 'app-typologie-lettre-card',
  templateUrl: './typologie-lettre-card.component.html',
  styleUrls: ['./typologie-lettre-card.component.scss']
})
export class TypologieLettreCardComponent implements OnInit {

  @Input() EditMode?: boolean;
  @Input() showPage?: boolean;
  @Input() showFormat?: boolean;
  @Input() showDimension?: boolean;
  @Input() showGrammage?: boolean;
  @Input() showFinition?: boolean;
  @Input() showEncre?: boolean;

  support: Support = new Support();

  navigationOption = {};

  navigationSubscription;

  constructor(
    private router: Router,
    private readonly activatedRoute: ActivatedRoute,
    public _GlobalDataService: GlobalDataService,
    private _ProduitService: ProduitService,
    private _CampagneTypologieService: CampagneTypologieService,

  ) {
    // subscribe to the router events. Store the subscription so we can
    // unsubscribe later.
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.initialise();
      }
    });
  }

  initialise() {
    this.navigationOption = { typologie: 'lettre' };
    this.support.typologie = '1 lettre';
    this.support.support = this._GlobalDataService.getLibelleProduit('CodeSupport', this._GlobalDataService.Campagne.CodeSupport, 'support')
    this.support.dimension = this._GlobalDataService.getLibelleProduit('CodeDimensionsSupport', this._GlobalDataService.Campagne.CodeDimensionsSupport, 'DimensionsSupport')
    this.support.grammage = this._GlobalDataService.getLibelleProduit('CodeGrammageSupport', this._GlobalDataService.Campagne.CodeGrammageSupport, 'GrammageSupport')
    this.support.finition = this._GlobalDataService.getLibelleProduit('CodeFinitionSupport', this._GlobalDataService.Campagne.CodeFinitionSupport, 'FinitionSupport')
    this.support.Encre = this._GlobalDataService.getLibelleProduit('CodeEncreSupport', this._GlobalDataService.Campagne.CodeEncreSupport, 'EncreSupport');
  }


  ngOnInit(): void {
    this.initialise();
  }

  changeFormat(): void {
    console.log('changeFormat');
    this._CampagneTypologieService.navigate(navPaths.format, this.activatedRoute.parent as ActivatedRoute, this.navigationOption);
  }

  changePage() {
    console.log('changePage');
    this._CampagneTypologieService.navigate(navPaths.page, this.activatedRoute.parent as ActivatedRoute, this.navigationOption);
  }

  changeDimension(): void {
    console.log('changeDimension');
    this._CampagneTypologieService.navigate(navPaths.dimension, this.activatedRoute.parent as ActivatedRoute, this.navigationOption);
  }

  changeGrammage(): void {
    console.log('changeGrammage');
    console.log('this._CampagneTypologieService.dataGrammagesSupports');
    console.log(this._CampagneTypologieService.dataGrammagesSupports);
    this._CampagneTypologieService.navigate(navPaths.grammage, this.activatedRoute.parent as ActivatedRoute, this.navigationOption);
  }

  changeFinition(): void {
    console.log('changeFinition');
    this._CampagneTypologieService.navigate(navPaths.finition, this.activatedRoute.parent as ActivatedRoute, this.navigationOption);
  }

  changeEncre(): void {
    console.log('changeEncre - this.navigationOption');
    console.log(this.navigationOption)
    this._CampagneTypologieService.navigate(navPaths.encre, this.activatedRoute.parent as ActivatedRoute, this.navigationOption);
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
}
